import { render, staticRenderFns } from "./clients-field.vue?vue&type=template&id=4a0ed360&scoped=true"
import script from "./clients-field.vue?vue&type=script&lang=js"
export * from "./clients-field.vue?vue&type=script&lang=js"
import style0 from "./clients-field.vue?vue&type=style&index=0&id=4a0ed360&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ed360",
  null
  
)

export default component.exports